import { LinkItemProps } from '../types/linkItemProps';

export const linkItemsForCSUser: Array<LinkItemProps> = [
    { name: 'Dashboard', icon: 'table-columns', url: '/dashboard' },
    { name: 'Playlists', icon: 'play-circle', url: '/playlist/' },
    { name: 'Classes', icon: 'graduation-cap', url: '/classes' },
    { name: 'Quizzes', icon: 'arrows-up-to-line', url: '/quiz' },
    { name: 'Institutions', icon: 'building-columns', url: '/institutions/list' },
    { name: 'FAM', icon: 'key', url: '/fam/list' },
    { name: 'Trials', icon: 'clock', url: '/trials/list' },
];

export const linkItemsForCSLTIUser: Array<LinkItemProps> = [
    { name: 'Dashboard', icon: 'table-columns', url: '/dashboard' },
    { name: 'Playlists', icon: 'play-circle', url: '/playlist/' },
    { name: 'Classes', icon: 'graduation-cap', url: '/classes' },
    { name: 'Quizzes', icon: 'arrows-up-to-line', url: '/quiz' },
    { name: 'Institutions', icon: 'building-columns', url: '/institutions/list' },
    { name: 'FAM', icon: 'key', url: '/fam/list' },
    { name: 'Trials', icon: 'clock', url: '/trials/list' },
    { name: 'LTI', icon: 'list-check', url: '/lti' },
];
